const positionOptions = ['Beginning', 'End', 'None'];
export const refreshActions = [
  {
    name: 'refreshSection',
    label: 'Refresh Section',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'refreshPage',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'refreshPageApi',
        options: [],
        value: '',
      },
      {
        name: 'refreshComponent',
        label: 'Select Refresh Component',
        type: 'dropdown',
        optionsType: 'refreshPageComponent',
        options: [],
        value: '',
      },
      {
        name: 'refreshComponentPosition',
        label: 'Select Append/Remove (Optional)',
        type: 'dropdown',
        optionsType: 'refreshPageComponentPosition',
        options: positionOptions,
        value: '',
      },
    ],
  },
];
